export function getTotalLength(sequencerEngine) {
    let bars = Math.max(
        30,
        Math.max(... sequencerEngine.mixes.map(m => m.length/32.0 + 16)));

    // get all the 

    return Math.floor(bars * 2);
};

